/**
 * Created by masterx2 on 26.02.16.
 */

(function (core) {
    'use strict';
    var rpc = Onicon.rpc,
        _ = Onicon._;

    Onicon.lib('callback',{

        init: function() {
            // Запускается сразу после загрузки модуля, если не запрещено флагом

        },

        ready: function() {
            // Запускается вместе со стартом ядра
        },

        makeVoxCall: function (phone, rule) {
            // default rule id = 679
            return rpc.call({
                ctrl: "vox",
                action: "makeCall",
                params: {
                    "tPhone": phone,
                    "rule": rule || 679
                }
            });
        }

    }, true);
})(Onicon.core);